import React from 'react'
import { AppBar, Toolbar, IconButton, MenuIcon, Menu, Badge, Typography } from '@material-ui/core'
import { ShoppingCart } from '@material-ui/icons'
import useStyles from './style'

import logo from '../../assets/logoCommerce.png'

import { Link, useLocation } from 'react-router-dom'

const Navbar = (props) => {
  const {totalProduct} = props
  const classes = useStyles()
  let location = useLocation();

  return (
    <>
    <AppBar className={classes.appBar} position="fixed" color="inherit">
      <Toolbar>
        <Typography component={Link} to="/" className={classes.title} variant="h6" color="inherit" align="center">
          <img className={classes.image} component={Link} to="/" src={logo} alt="Commerce.js" height="25px" />
          Commerce.js
        </Typography>
        <div className={classes.grow} />
        {location.pathname === '/' && (
        <div className={classes.button}>
          <IconButton component={Link} to="/cart" aria-label="Show cart items" color="inherit">
            <Badge badgeContent={totalProduct} color="secondary">
              <ShoppingCart />
            </Badge>
          </IconButton>
        </div>
        )}
      </Toolbar>
    </AppBar>
    </>
  )
}

export default Navbar
